import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DerogacionesValidarService } from '../../../../core/providers/services/derogaciones-validar/derogaciones-validar.service';

@Component({
  selector: 'app-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss']
})
export class ChipsComponent implements OnInit, OnChanges, OnDestroy {

  public currValue = '';

  /**
   * @description se le pasa el formulario base
   */
  @Input() FORM_DATA: FormGroup;
  @Input() DATA_CONFIG: any;
  @Input() REQUIRE_CHANGE: any;

  textInput = '';
  chips: string[] = [];
  fieldName: any;
  fieldErrors: any;
  fieldHasErrorB = false;
  fieldTouch = false;
  fieldRequired = false;
  crossTouch = false;
  serviceDerogaError = false;

  insureSelected: string;

  /**
   * @description se le pasa un array de strings que será el path que enlazará
   *  la propiedad del formulario al input
   * @example ['individualTravelAsistance', 'name']
   */
  constructor(
    private derogVSrv: DerogacionesValidarService
  ) {
    this.derogVSrv = derogVSrv;
  }

  finish = new Subject();
  /**
   * @description Metodo de inicio
   */
  ngOnInit(): void {
    // Si viene un valor del formulario o de la configuracion lo guardamos en el formulario
    this.insureSelected = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value.chosed;
    this.chips = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).valueChanges
      .pipe(
        takeUntil(this.finish)
      ).subscribe(chips => {
        this.chips = chips;
      });

    this.fieldName = this.DATA_CONFIG.linkFormPath;
    this.fieldRequired = false;
    if (this.REQUIRE_CHANGE) { this.fieldRequired = this.REQUIRE_CHANGE; }
    this.getError(this.fieldName);
  }
  /**
   * @description Metodo fin
   */
  ngOnDestroy(): void {
    this.finish.next(true);
  }
  /**
   * @description Metodo actualización
   * @params changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataChange !== undefined && changes.dataChange.currentValue !== undefined) {
      const AUX_CHANGE: any = changes.dataChange.currentValue;
      if (AUX_CHANGE.name !== undefined) {
        //
      }
    }
  }

  /**
   * @description Es para comprobar que todos los inputs tienen datos para poder iniciar el componente
   */
  public checkDataCompOk(): boolean {
    return this.FORM_DATA && this.DATA_CONFIG && this.DATA_CONFIG.linkFormPath && this.DATA_CONFIG.linkFormPath.length > 0;
  }

  /**
   * @description Actualiza los cambios del input desde el html
   */
  public updateData(): void {
    let errorsA: ValidationErrors = null;
    let errorE = false;
    const ERRORS: ValidationErrors = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).errors;
    if (!this.checkDataCompOk() || this.textInput.length === 0) { return; }
    // metemos una chip a la lista de chips
    // Valor del formulario
    this.derogVSrv.getCheckDerogationCode(this.textInput)
      .pipe(take(1))
      .subscribe((codeStatus) => {
        if (codeStatus) {
          const VALUE_DATA: any[] = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
          if (VALUE_DATA.findIndex(el => el === this.textInput) < 0) {
            VALUE_DATA.push(this.textInput);
            this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(VALUE_DATA);
          }
        }
        // Borramos el campo del input
        this.textInput = '';


        if (this.fieldRequired && this.chips.length === 0) {
          this.fieldHasErrorB = true;
          this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
        } else {
          if (this.fieldRequired) {
            this.fieldHasErrorB = false;
            if (ERRORS !== null) {
              delete ERRORS.required;
              errorE = Object.keys(ERRORS).length === 0;
            }
            if (errorE === true) { errorsA = null;
            } else { errorsA = ERRORS; }

            this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors(errorsA);
            this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).updateValueAndValidity();
          }
        }

        if (codeStatus) {
          this.serviceDerogaError = false;
          this.fieldHasErrorB = false;
          if (ERRORS !== null) {
            delete ERRORS.required;
            errorE = Object.keys(ERRORS).length === 0;
          }
          if (errorE === true) { errorsA = null;
          } else { errorsA = ERRORS; }

          this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors(errorsA);
          this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).updateValueAndValidity();
        } else {
          this.serviceDerogaError = true;
          this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
        }
      });
  }
  /**
   * @description Borrar chip
   * @params name
   */
  deleteChip(name: string): void {
    let errorsA: ValidationErrors = null;
    let errorE = false;
    const ERRORS: ValidationErrors = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).errors;
    const VALUE_DATA: string[] = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
    const IDX_TO_DELETE: number = VALUE_DATA.findIndex(chip => name === chip);
    VALUE_DATA.splice(IDX_TO_DELETE, 1);
    this.chips = VALUE_DATA;
    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(VALUE_DATA);
    this.crossTouch = true;


    if (this.fieldRequired && this.chips.length === 0) {
      this.fieldHasErrorB = true;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    } else {
      if (this.fieldRequired) {
        this.fieldHasErrorB = false;
        if (ERRORS !== null) {
          delete ERRORS.required;
          errorE = Object.keys(ERRORS).length === 0;
        }
        if (errorE === true) {
          errorsA = null;
        } else {
          errorsA = ERRORS;
        }

        this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors(errorsA);
        this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).updateValueAndValidity();
      }
    }
  }

  /**
   * @description Actualiza los cambios del input desde el html
   */
  // public getFormValue(): any {
  //   let result: any;
  //   if (this.checkDataCompOk()) {
  //     result = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
  //   }
  //   return result;
  // }

  /**
   *
   * @param field field to mark focus
   */
  onFocusInput(controlName: any): void {
    this.FORM_DATA.get(controlName).markAsUntouched();
    this.fieldTouch = true;
    const VALUE_EL: any = this.FORM_DATA.get(controlName).value;
    if (this.fieldRequired && VALUE_EL !== '') {
      this.fieldHasErrorB = false;
    } else {
      if (this.fieldRequired) {
        this.fieldHasErrorB = true;
      }
   }
  }

  /**
   *
   * @param field field to check erros
   */
  getError(controlName: string): string {
    let errorMsg = '';
    this.fieldErrors = '';
    const CONTROL: AbstractControl = this.FORM_DATA.get(controlName);
    this.fieldRequired = false;
    if (this.DATA_CONFIG.requiredText !== '') { this.fieldRequired = true; }
    if (CONTROL.invalid && CONTROL.errors !== null) {
      errorMsg = JSON.stringify(CONTROL.errors);
      this.fieldErrors = CONTROL.errors;
    }
    return errorMsg;
  }
}
